import { render, staticRenderFns } from "./batchAllocation.vue?vue&type=template&id=81b3e8e0&scoped=true&"
import script from "./batchAllocation.vue?vue&type=script&lang=ts&"
export * from "./batchAllocation.vue?vue&type=script&lang=ts&"
import style0 from "./batchAllocation.vue?vue&type=style&index=0&id=81b3e8e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b3e8e0",
  null
  
)

export default component.exports